// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"c0f79b1c","51":"077c7d91","149":"11747177","650":"2dfbc06e"}[chunkId] + ".chunk.css";
};